import React from 'react';
import { Navigate, RouteProps } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Urls, useAuth } from '../../context';

const EmployeeCompanyRoute: React.FC<RouteProps> = props => {
	const auth = useAuth();
	const hasAccess = auth.isAuthenticated && (auth.currentUser.isCompanyUser || auth.currentUser.isEmployeeUser);

	return hasAccess ? <Outlet /> : <Navigate to={Urls.Documents.Root} />;
};

export default EmployeeCompanyRoute;
